import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-6" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap justify-content-between" }
const _hoisted_4 = { class: "me-5" }
const _hoisted_5 = { class: "me-0 mb-0 text-end" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex overflow-auto h-55px" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link text-active-primary me-6 active",
        href: "#tabs_edit_general",
        "data-bs-toggle": "tab"
      }, "Thông tin chung")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link text-active-primary me-6",
        href: "#tabs_edit_seo",
        "data-bs-toggle": "tab"
      }, "SEO")
    ])
  ])
], -1)
const _hoisted_8 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_9 = { class: "card-body pt-10" }
const _hoisted_10 = { class: "tab-content" }
const _hoisted_11 = {
  class: "tab-pane fade active show",
  id: "tabs_edit_general",
  role: "tabpanel"
}
const _hoisted_12 = { class: "my-5 px-8" }
const _hoisted_13 = { class: "row g-9 mb-8" }
const _hoisted_14 = { class: "col-md-12 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Tiêu đề danh mục", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Tiêu đề H1", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Đường dẫn danh mục", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Danh cha", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fv-row mt-0" }, null, -1)
const _hoisted_21 = {
  class: "tab-pane fade",
  id: "tabs_edit_seo",
  role: "tabpanel"
}
const _hoisted_22 = { class: "col-md-12 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Robots", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Tiêu đề seo", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Nội dung seo", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_editor = _resolveComponent("editor")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "kt_modal_new_target_form",
    model: _ctx.objectDetail,
    rules: _ctx.rules,
    ref: "formRef",
    class: "form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.objectDetail.name), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn-primary btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ]),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.convertNameToSlug(_ctx.objectDetail.name))),
                          modelValue: _ctx.objectDetail.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objectDetail.name) = $event)),
                          placeholder: "Tiêu đề danh mục",
                          name: "name"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_16,
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectDetail.title_h1,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objectDetail.title_h1) = $event)),
                          placeholder: "Tiêu đề H1",
                          name: "name"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_17,
                    _createVNode(_component_el_form_item, { prop: "slug" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.convertNameToSlug(_ctx.objectDetail.slug))),
                          modelValue: _ctx.objectDetail.slug,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objectDetail.slug) = $event)),
                          placeholder: "Nhập vào họ và tên",
                          name: "slug"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_18,
                    _createVNode(_component_el_form_item, { prop: "categories" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.objectDetail.parent,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.objectDetail.parent) = $event)),
                          clearable: "",
                          placeholder: "Danh cha"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataNewsCategory, (role, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: role.name,
                                value: role._id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_19,
                    _createVNode(_component_editor, {
                      "api-key": "eik426uetuniwvflvp9ffcqc9kr6j4bt8lgskfghdki0lsjf",
                      modelValue: _ctx.objectDetail.short_desc,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.objectDetail.short_desc) = $event)),
                      init: _ctx.editorConfig
                    }, null, 8, ["modelValue", "init"]),
                    _createVNode(_component_el_form_item, { label: "Hiển thị" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.objectDetail.frontend,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.objectDetail.frontend) = $event)),
                          "active-color": "#13ce66",
                          "inactive-color": "#ff4949"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_20
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_el_form_item, { prop: "robot" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.objectDetail.seo.robot,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.objectDetail.seo.robot) = $event)),
                      placeholder: "",
                      name: "robot"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "index, follow",
                          value: "index, follow"
                        }),
                        _createVNode(_component_el_option, {
                          label: "index, nofollow",
                          value: "index, nofollow"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_24,
                _createVNode(_component_el_form_item, { prop: "seo.title" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.objectDetail.seo.title,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objectDetail.seo.title) = $event)),
                      placeholder: "",
                      name: "seo_title"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_25,
                _createVNode(_component_el_form_item, { prop: "seo.description" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.objectDetail.seo.description,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.objectDetail.seo.description) = $event)),
                      placeholder: "",
                      name: "seo_des",
                      rows: "4",
                      type: "textarea"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}